module.exports = __webpack_public_path__ + "img/beneficiary-link.1ee2e18b.svg";